<template>
  <div class="card card-modern pt-3" style="margin-top: 20px;">
    <div class="card-header card-header-tabs">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <span class="nav-tabs-title" style="font-weight: bold;">Estado de: {{estado.nome}}</span>
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="nav-item" v-for="(a, i) in acoes" :key="i">
              <a :class="'nav-link' + (acao == a.acao ? ' active show' : '')"
                 data-toggle="tab"
                 style="cursor: pointer"
                 @click="acao = a.acao">
                <i class="material-icons">{{ a.icone }}</i> {{ a.nome }}
                <div class="ripple-container"></div>
                <div class="ripple-container"></div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div v-if="kpi != null">
        <TotaisEstado :estado_id="estado.id" :totaisEstadoInit="totaisEstado" v-if="acao == 'totaisEstado' && totaisEstado != null" ></TotaisEstado>
        <Kpi :kpiinit="kpi" v-if="acao == 'score'"></Kpi>
        <Classe :kpiinit="kpi" v-if="acao == 'classe'"></Classe>
        <Difusao
          :difusaoinit="difusao"
          v-if="acao == 'difusao' && difusao != null"
        ></Difusao>
        <Analise
          :kpisinit="kpiAnalise"
          :analiseinit="analise"
          v-if="acao == 'analise' && analise != null"
        ></Analise>

        <div style="display: flex; height: 300px" v-if="((acao == 'difusao' && difusao == null) || (acao == 'analise' && analise == null) || (acao == 'totaisEstado' && totaisEstado == null))">
          <div class="lds-spinner" style="margin: auto">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div style="display: flex; height: 300px" v-else>
          <div class="lds-spinner" style="margin: auto">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import TotaisEstado from "./indicadores/TotaisEstado.vue";
import Kpi from "./indicadores/Kpi.vue";
import Classe from "./indicadores/Classe.vue";
import Difusao from "./indicadores/Difusao.vue";
import Analise from "./indicadores/Analise.vue";

export default {
  props: ["estadoini"],
  components: { TotaisEstado, Kpi, Classe, Difusao, Analise },
  data() {
    return {
      acoes: [
        { nome: "Mapa", icone: "public", acao: "mapa" },
        { nome: "Totais do Estado", icone: "assessment", acao: "totaisEstado" },
        { nome: "Score", icone: "grid_on", acao: "score" },
        { nome: "Classe de Desempenho", icone: "analytics", acao: "classe" },
        { nome: "Taxa de Difusão", icone: "show_chart", acao: "difusao" },
        { nome: "Análise", icone: "table_chart", acao: "analise" },
      ],
      acao: "totaisEstado",
      kpi: null,
      kpiAnalise: null,
      estado: this.estadoini,
      difusao: null,
      analise: null
    };
  },
  methods: {
    buscarTotaisEstado(estadoId = this.estado.id) {
      callAPI(
        "/estado/totais/" + estadoId,
        "GET",
        null,
        (totaisEstado) => {
          this.totaisEstado = totaisEstado;
        }
      );
    },
    buscarKpis(estadoId = this.estado.id) {
      callAPI(
        "/kpi/all/" + estadoId,
        "GET",
        null,
        (kpi) => {
          this.kpi = kpi;
        }
      );

      callAPI(
        "/kpi/all",
        "GET",
        null,
        (kpiAnalise) => {
          this.kpiAnalise = kpiAnalise;
        }
      );
    },
    buscarDifusao(estadoId = this.estado.id) {
      callAPI(
        "/estado/difusao/" + estadoId,
        "GET",
        null,
        (difusao) => {
          this.difusao = difusao;
        }
      );
    },
    buscarAnalise(estadoId = this.estado.id) {
      callAPI(
        "/estado/analise/" + estadoId,
        "GET",
        null,
        (analise) => {
          this.analise = analise;
        }
      );
    }
  },
  created() {
    this.buscarTotaisEstado();
    this.buscarKpis();
    this.buscarDifusao();
    this.buscarAnalise();
  },
  watch: {
    acao(acao) {
      if (acao == "mapa") {
        this.$emit("mapa");
      }
    },
  },
};
</script>

<style scoped>
.card-header-tabs {
  background: transparent !important;
  box-shadow: none !important;
  margin-bottom: 20px;
  padding: 0 !important;
}
.nav-tabs-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.nav-tabs-wrapper .nav-tabs-title {
  color: #333;
  font-size: 1.2rem;
  margin-right: 20px;
}
.nav-tabs {
  border-bottom: none !important;
  display: flex;
  gap: 10px;
  background: transparent !important;
}
.nav-tabs .nav-link {
  border: none !important;
  border-radius: 30px !important;
  color: #666 !important;
  font-weight: 500;
  padding: 8px 16px !important;
  transition: all 0.3s ease;
  background-color: #f4f7f6 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 !important;
}
.nav-tabs .nav-link:hover {
  background-color: #e2e8e5 !important;
  color: #333 !important;
}
.nav-tabs .nav-link.active {
  background-color: #ff9800 !important; /* Solar brand accent */
  color: #fff !important;
  box-shadow: 0 4px 10px rgba(255, 152, 0, 0.3) !important;
}
.nav-tabs .nav-link i.material-icons {
  font-size: 20px;
  margin: 0 !important;
}
</style>
